'use client';

import { useState } from 'react';
import { Play, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

const VIDEO_EMBED_URL = 'https://drive.google.com/file/d/1I-b6ru7lNvRv6ga0x_rZO9JQNWHNme5h/preview';

interface VideoButtonProps {
  label?: string;
  className?: string;
}

export default function VideoButton({ label = 'See More', className }: VideoButtonProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        size="lg"
        className={className}
        onClick={() => setOpen(true)}
      >
        <Play className="mr-2 h-5 w-5" /> {label}
      </Button>

      {/* Video Modal */}
      {open && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" onClick={() => setOpen(false)}>
          <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" />
          <div
            className="relative w-full max-w-4xl animate-in fade-in zoom-in-95 duration-200"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close button */}
            <button
              onClick={() => setOpen(false)}
              className="absolute -top-12 right-0 text-white/70 hover:text-white transition-colors flex items-center gap-2 text-sm"
            >
              Close <X className="h-5 w-5" />
            </button>

            {/* Video embed */}
            <div className="relative w-full rounded-2xl overflow-hidden border border-white/10 shadow-2xl" style={{ paddingTop: '56.25%' }}>
              <iframe
                src={VIDEO_EMBED_URL}
                className="absolute inset-0 w-full h-full"
                allow="autoplay; encrypted-media"
                allowFullScreen
                title="Paylink Solutions Demo"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
